import * as constants from 'constants'

import { ValueOf } from '~/types/value-of'

export const SOCIAL_SHARE = {
  twitter: {
    name: 'X',
    icon: 'social/twitter',
    shareUrl: 'https://twitter.com/intent/tweet?url='
  },
  telegram: {
    name: 'Telegram',
    icon: 'social/telegram',
    shareUrl: 'https://t.me/share/url?url='
  },
  linkedin: {
    name: 'LinkedIn',
    icon: 'social/linkedin',
    shareUrl: 'https://www.linkedin.com/sharing/share-offsite/?url='
  },
  facebook: {
    name: 'Facebook',
    icon: 'social/facebook',
    shareUrl: 'https://www.facebook.com/sharer/sharer.php?u='
  },
  // reddit: {
  //   name: 'Reddit',
  //   icon: 'social/reddit',
  //   shareUrl: 'https://www.reddit.com/submit?url='
  // },
} as const

 